import { post } from '@/util/auth'

import type { OffBoardingPayload } from './types'

const offBoardingResources = {
  post: (payload: OffBoardingPayload) => post('form/:code/termination', payload),
}

export default offBoardingResources
